'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ids;

var _entries2 = require('./_entries');

var _entries3 = _interopRequireDefault(_entries2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ids(root, listName, start, end) {
    return (0, _entries3.default)(root, listName, start, end).map(function (entry) {
        return entry && entry.id;
    });
}